<template>
  <!-- 空译文 -->
  <div class="component__tu-status" title="未翻译" v-if="isCellEmpty">
    <font-awesome-icon
      class="component__tu-status component__tu-status--empty"
      :icon="['far', 'file']"
      size="lg"
    >
    </font-awesome-icon>
  </div>
  <!-- 翻译中 -->
  <div
    class="component__tu-status"
    title="翻译中"
    v-else-if="status === TU_STATUS.translating"
  >
    <font-awesome-icon
      class="component__tu-status component__tu-status--translating"
      icon="pencil-alt"
      size="lg"
    >
    </font-awesome-icon>
  </div>
  <!-- 翻译已确认 -->
  <div
    class="component__tu-status component__tu-status--translated"
    title="翻译已确认"
    v-else-if="status === TU_STATUS.translated"
  >
    <font-awesome-icon icon="pencil-alt" size="lg"> </font-awesome-icon>
    <font-awesome-icon icon="check"></font-awesome-icon>
  </div>
  <!-- 审校中 -->
  <div
    class="component__tu-status"
    v-else-if="status === TU_STATUS.reviewing"
    title="审校中"
  >
    <font-awesome-icon
      class="component__tu-status component__tu-status--reviewing"
      icon="search"
      flip="horizontal"
      size="lg"
    ></font-awesome-icon>
  </div>

  <!-- 审校已确认 -->
  <div
    class="component__tu-status component__tu-status--review-passed"
    title="审校已确认"
    v-else-if="status === TU_STATUS.reviewPassed"
  >
    <font-awesome-icon icon="search" flip="horizontal" size="lg">
    </font-awesome-icon>
    <font-awesome-icon icon="check"></font-awesome-icon>
  </div>
  <!-- 审校已拒绝 -->
  <div
    class="component__tu-status component__tu-status--rejected-by-reviewer"
    title="审校已拒绝"
    v-else-if="status === TU_STATUS.rejectedByReviewer"
  >
    <font-awesome-icon icon="search" flip="horizontal" size="lg">
    </font-awesome-icon>
    <font-awesome-icon icon="times"></font-awesome-icon>
  </div>
  <!-- 终审中 -->
  <div
    class="component__tu-status component__tu-status--proofreading"
    title="通读中"
    v-else-if="status === TU_STATUS.proofreading"
  >
    <font-awesome-icon icon="file" size="lg"> </font-awesome-icon>
    <font-awesome-icon icon="search"></font-awesome-icon>
  </div>

  <!-- 终审已确认 -->
  <div
    class="component__tu-status component__tu-status--proofread-passed"
    title="通读已确认"
    v-else-if="
      status === TU_STATUS.proofreadPassed ||
      status === TU_STATUS.commentByTeacher
    "
  >
    <font-awesome-icon icon="file" size="lg"> </font-awesome-icon>
    <font-awesome-icon icon="search"></font-awesome-icon>
    <font-awesome-icon icon="check"></font-awesome-icon>
  </div>
  <!-- 终审已拒绝 -->
  <div
    class="component__tu-status component__tu-status--rejected-by-proofreader"
    v-else-if="status === TU_STATUS.rejectedByProofreader"
    title="通读已拒绝"
  >
    <font-awesome-icon icon="file" size="lg"> </font-awesome-icon>
    <font-awesome-icon icon="search"></font-awesome-icon>
    <font-awesome-icon icon="times"></font-awesome-icon>
  </div>
</template>

<script>
import { TU_STATUS } from "./data";
export default {
  name: "TuStatus",
  props: {
    status: Number,
    isCellEmpty: Boolean,
  },
  data() {
    return {
      TU_STATUS,
    };
  },
};
</script>

<style lang="scss">
.component__tu-status {
  line-height: 2;
  display: inline-block;
  &--translating {
    color: #409eff;
  }
  &--translated,
  &--review-passed {
    position: relative;
    display: inline-block;
    color: #67c23a;
    .fa-check {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  &--reviewing {
    color: #409eff;
  }

  &--rejected-by-reviewer {
    position: relative;
    display: inline-block;
    color: #f56c6c;
    .fa-times {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }

  &--proofreading {
    position: relative;
    display: inline-block;
    color: #409eff;
    .fa-search {
      color: #fff;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  &--proofread-passed {
    position: relative;
    display: inline-block;
    color: #67c23a;
    .fa-check {
      position: absolute;
      bottom: -0.25em;
      right: -0.25em;
    }
    .fa-search {
      color: #fff;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }

  &--rejected-by-proofreader {
    position: relative;
    display: inline-block;
    color: #f56c6c;
    .fa-times {
      position: absolute;
      bottom: -0.25em;
      right: -0.25em;
    }
    .fa-search {
      color: #fff;
      position: absolute;
      margin: auto;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}
</style>